var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useCallback } from 'react';
import { faSquarePlus } from '@fortawesome/pro-light-svg-icons/faSquarePlus';
import { faMagnifyingGlassMinus } from '@fortawesome/pro-regular-svg-icons/faMagnifyingGlassMinus';
import { faMagnifyingGlassPlus } from '@fortawesome/pro-regular-svg-icons/faMagnifyingGlassPlus';
import { faRotate } from '@fortawesome/pro-regular-svg-icons/faRotate';
import { faMagnifyingGlassArrowRight } from '@fortawesome/pro-regular-svg-icons/faMagnifyingGlassArrowRight';
import { faUpRightAndDownLeftFromCenter } from '@fortawesome/pro-regular-svg-icons/faUpRightAndDownLeftFromCenter';
import { faSearch } from '@fortawesome/pro-regular-svg-icons/faSearch';
import { useDispatch } from 'react-redux';
import { useReactFlow } from 'reactflow';
import { Divider, Icon } from '../SbGlobal/styles';
import { Float, IconContainer } from './styles';
import { sbColors as colors } from 'components/UI-helpers/colors';
import { changeAddPatchModalState, changeLBAddPatchModalState, changeLBSearchPatchState, changeSearchPatchState, updateModalPosition, } from 'store/structureBuilderUI/reducer';
import { ACTION_PERMISSIONS, PERMISSIONS } from '../SbGlobal/constants';
import { Tooltip } from 'app-builder/root/layout/AppBuilderSideBar';
var zoomOptions = { duration: 300 };
export var FloatingMenu = function (_a) {
    var onRefreshPatchwork = _a.onRefreshPatchwork, permissions = _a.permissions, onFindHome = _a.onFindHome, _b = _a.isSB, isSB = _b === void 0 ? false : _b;
    var dispatch = useDispatch();
    var _c = useReactFlow(), zoomIn = _c.zoomIn, zoomOut = _c.zoomOut, fitView = _c.fitView;
    var isViewOnly = useMemo(function () {
        return ((permissions === null || permissions === void 0 ? void 0 : permissions.includes(PERMISSIONS.READ)) &&
            !ACTION_PERMISSIONS.some(function (action) { return permissions === null || permissions === void 0 ? void 0 : permissions.includes(action); }));
    }, [permissions]);
    var actions = useMemo(function () { return ({
        openPatchModal: function () {
            dispatch(changeAddPatchModalState(true));
        },
        updateModalPosition: function (position) {
            dispatch(updateModalPosition(position));
        },
    }); }, [dispatch]);
    var handleZoomIn = useCallback(function () {
        zoomIn(zoomOptions);
    }, [zoomIn]);
    var handleZoomOut = useCallback(function () {
        zoomOut(zoomOptions);
    }, [zoomOut]);
    var hanldePanout = useCallback(function () {
        fitView(zoomOptions);
    }, [fitView]);
    var handleOnOpenPatchModal = function () {
        actions.updateModalPosition(null);
        isSB
            ? dispatch(changeAddPatchModalState(true))
            : dispatch(changeLBAddPatchModalState(true));
    };
    var handleSearchModal = function () {
        actions.updateModalPosition(null);
        isSB
            ? dispatch(changeSearchPatchState(true))
            : dispatch(changeLBSearchPatchState(true));
    };
    return (_jsxs(Float, { children: [!isViewOnly && (_jsxs(_Fragment, { children: [_jsx(Tooltip, __assign({ title: "Add patch" }, { children: _jsx(IconContainer, __assign({ onClick: handleOnOpenPatchModal }, { children: _jsx(Icon, { iconSize: 32, icon: faSquarePlus, color: colors.default, className: "cursor-pointer" }) })) })), _jsx(Divider, { marginVr: 8 })] })), _jsxs(_Fragment, { children: [_jsx(Tooltip, __assign({ title: "Search patch" }, { children: _jsx(IconContainer, __assign({ onClick: handleSearchModal }, { children: _jsx(Icon, { iconSize: 20, icon: faSearch, color: colors.default, className: "cursor-pointer" }) })) })), _jsx(Tooltip, __assign({ title: "Find home" }, { children: isSB && (_jsx(IconContainer, __assign({ onClick: onFindHome }, { children: _jsx(Icon, { iconSize: 20, icon: faMagnifyingGlassArrowRight, color: colors.default, className: "cursor-pointer" }) }))) })), _jsx(Divider, { marginVr: 8 })] }), _jsx(Tooltip, __assign({ title: "Zoom in" }, { children: _jsx(IconContainer, __assign({ onClick: handleZoomIn }, { children: _jsx(Icon, { iconSize: 20, icon: faMagnifyingGlassPlus, color: colors.default, className: "cursor-pointer" }) })) })), _jsx(Tooltip, __assign({ title: "Zoom out" }, { children: _jsx(IconContainer, __assign({ onClick: handleZoomOut }, { children: _jsx(Icon, { iconSize: 20, icon: faMagnifyingGlassMinus, color: colors.default, className: "cursor-pointer" }) })) })), _jsx(Tooltip, __assign({ title: "Fit view" }, { children: _jsx(IconContainer, __assign({ onClick: hanldePanout }, { children: _jsx(Icon, { iconSize: 20, icon: faUpRightAndDownLeftFromCenter, color: colors.default, className: "cursor-pointer" }) })) })), _jsx(Divider, { marginVr: 8 }), _jsx(Tooltip, __assign({ title: "Refresh" }, { children: _jsx(IconContainer, __assign({ onClick: onRefreshPatchwork }, { children: _jsx(Icon, { iconSize: 20, icon: faRotate, color: colors.default, className: "cursor-pointer" }) })) }))] }));
};
